import { render } from "./List.vue?vue&type=template&id=3bf0d7dd&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=3bf0d7dd&lang=less&scoped=true"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf0d7dd"]])

export default __exports__